<div class="encabezado">
  <h5 class="titulo1">{{ "settings.title" | translate }}</h5>
  <div class="row settings-grid">
    <div class="col-12 col-md-6">
      <a routerLink="/settings/profile">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <img
              src="assets/images/setting.png"
              class="img-fluid"
              alt=""
              height="22"
            />
          </div>
          <div class="text">
            <h3>{{ "settings.profile.cardtitle" | translate }}</h3>
            <p>
              {{ "settings.profile.cardtext" | translate }}
            </p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>
    <div class="col-12 col-md-6">
      <a routerLink="/settings/users">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <img
              src="assets/images/setting-users.png"
              class="img-fluid"
              alt=""
              height="22"
            />
          </div>
          <div class="text">
            <h3>{{ "settings.user.cardtitle" | translate }}</h3>
            <p>
              {{ "settings.user.cardtext" | translate }}
            </p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>
  </div>
  <div class="row settings-grid">
    <div class="col-12 col-md-6">
      <a routerLink="/settings/automation">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <img
              src="assets/images/setting-notif.png"
              class="img-fluid"
              alt=""
              height="22"
            />
          </div>
          <div class="text">
            <h3>{{ "automation.cardtitle" | translate }}</h3>
            <p>
              {{ "automation.cardtext" | translate }}
            </p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>
    <div class="col-12 col-md-6">
       <a routerLink="/settings/tags">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <img
              src="assets/images/setting-tag.png"
              class="img-fluid"
              alt=""
              height="22"
            />
          </div>
          <div class="text">
            <h3>{{ "settings.tags.title" | translate }}</h3>
            <p>{{ "settings.tags.description" | translate }}</p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>

  </div>
  <div class="row settings-grid">
    <div class="col-12 col-md-6">
      <a routerLink="/settings/mail">
        <div class="setting-card" (click)="changeOpt()">
         <div class="iconleft">
            <img
              src="assets/images/setting-email.png"
              class="img-fluid"
              alt=""
              height="22"
            />
          </div>
          <div class="text">
            <h3>{{ "settings.mail.cardtitle" | translate }}</h3>
            <p>{{ "settings.mail.cardtext" | translate }}</p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>
    <div class="col-12 col-md-6">
      <a routerLink="/settings/notification-reminders">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <img
              src="assets/images/setting-notif.png"
              class="img-fluid"
              alt=""
              height="22"
            />
          </div>
          <div class="text">
            <h3>{{ "notification_reminders.cardtitle" | translate }}</h3>
            <p>{{ "notification_reminders.cardtext" | translate }}</p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>
  </div>

  <!-- Account IMAP + VoIP Lines -->
  <div class="row settings-grid">
    <div class="col-12 col-md-6">
      <a routerLink="/settings/account-imap">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <i class="icon-inbox" style="font-size: 2rem; color: var(--color-primary-500, #3800a2);"></i>
          </div>
          <div class="text">
            <h3>{{ "settings.account_imap.cardtitle" | translate }}</h3>
            <p>{{ "settings.account_imap.cardtext" | translate }}</p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>
    <!-- VoIP Lines card hidden until implementation is ready -->
    <!-- <div class="col-12 col-md-6">
      <a routerLink="/settings/voip-lines">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <i class="icon-telephone" style="font-size: 2rem; color: var(--color-primary-500, #3800a2);"></i>
          </div>
          <div class="text">
            <h3>{{ "settings.voip_lines.cardtitle" | translate }}</h3>
            <p>{{ "settings.voip_lines.cardtext" | translate }}</p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div> -->
  </div>

  <!-- Order Freeze — solo supplier Admin -->
  <div class="row settings-grid" *ngIf="isSupplier">
    <div class="col-12 col-md-6">
      <a routerLink="/settings/order-freeze">
        <div class="setting-card" (click)="changeOpt()">
          <div class="iconleft">
            <i class="icon-lock" style="font-size: 2rem; color: var(--color-primary-500, #3800a2);"></i>
          </div>
          <div class="text">
            <h3>{{ "settings.order_freeze.cardtitle" | translate }}</h3>
            <p>{{ "settings.order_freeze.cardtext" | translate }}</p>
          </div>
          <div class="iconright">
            <i class="icon-chevron-right"></i>
          </div>
        </div>
      </a>
    </div>
  </div>

  <div *ngIf="opt" class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</div>
